import BillDateTitleWithTimezone from '@/common/components/BillDateTitleWithTImezone';
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper';
import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import { ShowHeader } from "@/common/components/ShowHeader";
import BillHeaderDropdownActions from '@/features/billingBills/components/HeaderDropdownActions';
import useBillingBill from "@/features/billingBills/hooks/useBillingBill";
import BillingBillsShow from "@/features/billingBills/pages/Show";
import { BriefcaseBusinessIcon } from "lucide-react";
import { useParams } from "react-router-dom";

const EstablishmentCompanyBillShow = () => {
  const { id, billId } = useParams();

  const {
    data: bill,
    error: billError = {} as any,
    refetch: refetchBill,
    isPending: billIsPending,
  } = useBillingBill({ id: billId });

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-64px)]"
      statusCode={billError?.status}
      refetchFunction={refetchBill}
      notFoundFallback={`/establishments/${id}/bills`}
      notFoundButtonText={'Ir para Faturas'}
    >
      <div>
        <ShowHeader
          goBack
          goBackProps={{ fallback: `/establishments/${id}/bills`, searchLastRouteFromFallback: true }}
          isLoading={billIsPending}
          LogoPlaceholder={(
            <ImageWithPlaceholder
              url={bill?.establishment_company?.general_information?.company_logo?.url}
              placeholderIcon={BriefcaseBusinessIcon}
              className="size-6"
              iconClassName="size-4"
            />
          )}
          title={bill?.establishment_company?.general_information?.fantasy_name}
          titleClassName="text-nowrap max-w-56 overflow-hidden text-ellipsis font-normal text-md"
          subtitle={(
            <div className='flex items-center gap-1'>
              <p>
                Fatura {bill?.number}
              </p>

              <BillDateTitleWithTimezone
                startDate={bill?.opened_at}
                endDate={bill?.closed_at}
                timezone={bill?.time_zone}
              />
            </div>
          )}
          subtitleClassName="text-nowrap font-medium"
          buttons={<BillHeaderDropdownActions bill={bill} />}
        />

        <BillingBillsShow billType="establishment_bills" />
      </div>
    </ErrorMessageWrapper>
  );
};

export default EstablishmentCompanyBillShow;
